<mf-grid
  #grid
  actionButtonText="{{ showCreateButton ? 'Nueva orden de cobro' : '' }}"
  [hideFilters]="hideFilters"
  [disableActionButton]="disableCreateButton"
  [actionButtonAsSecondary]="actionButtonAsSecondary"
  [initialFilters]="filters"
  [apiEndpoint]="apiEndpoint"
  [columns]="columns"
  [menuItems]="menuItems"
  [mustIncludeFields]="mustIncludeFields"
  [preventHeightResize]="true"
  (actionButtonClick)="openNewCollectOrderPopup()" />
